<!--
 * @Author: zhaoliang
 * @Date: 2023-04-11 10:33:31
 * @LastEditTime: 2026-05-11 15:21:43
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/SignUpMFA/components/step2/index.vue
 *
-->
<template>
  <div>
    <div class="signup-box-title">
      <img src="~img/icon-lock-black.svg" alt="lock" />
      <span>{{ $i18n.t('signup-userdetails-title') }}</span>
    </div>
    <div class="signup-box-form">
      <div class="signup-form">
        <!-- sign firstname输入框 -->
        <div class="form-item-group">
          <div class="form-item-label">
            <label for="fname">
              {{ $i18n.t('fname') }} {{ $i18n.t('signup-userdetails-sublabel') }}*
            </label>
          </div>
          <div class="form-item-component">
            <SafeInput
              :className="{ 'signup-form-item': true, 'input-border-err': fnameInfoErr }"
              :type="fnameInputType"
              id="fname"
              :placeholder="$i18n.t('fname')"
              autocomplete="new-password"
              role="input firstname"
              v-model.trim="formData.fname"
              maxlength="35"
              @input="
                e => {
                  handleValueChange(e, 'fname');
                }
              "
            />
            <img
              v-show="showFName"
              class="eye"
              src="~img/icon-feather-eye-on.svg"
              @click="changeFNameInputStatus('password')"
              alt="hide firstname"
            />
            <img
              v-show="!showFName"
              class="eye"
              src="~img/icon-feather-eye-off.svg"
              @click="changeFNameInputStatus('text')"
              alt="show firstname"
            />
          </div>
          <!-- check 错误提示 -->
          <p v-if="fnameInfoErr" class="error-message">{{ fnameErrMsg }}</p>
        </div>
        <!-- signup lastname输入框 -->
        <div class="form-item-group">
          <div class="form-item-label">
            <label for="lname">
              {{ $i18n.t('lname') }} {{ $i18n.t('signup-userdetails-sublabel') }}*
            </label>
          </div>
          <div class="form-item-component">
            <SafeInput
              :className="{ 'signup-form-item': true, 'input-border-err': lnameInfoErr }"
              :type="lnameInputType"
              id="lname"
              :placeholder="$i18n.t('lname')"
              autocomplete="new-password"
              role="input lastname"
              v-model.trim="formData.lname"
              maxlength="35"
              @input="
                e => {
                  handleValueChange(e, 'lname');
                }
              "
            />
            <img
              v-show="showLName"
              class="eye"
              src="~img/icon-feather-eye-on.svg"
              @click="changeLNameStatus('password')"
              alt="hide lastname"
            />
            <img
              v-show="!showLName"
              class="eye"
              src="~img/icon-feather-eye-off.svg"
              @click="changeLNameStatus('text')"
              alt="show lastname"
            />
          </div>
          <!-- check 错误提示 -->
          <p v-if="lnameInfoErr" class="error-message">{{ lnameErrMsg }}</p>
        </div>
        <!-- signup 日期输入框 -->
        <div class="form-item-group">
          <div class="form-item-label">
            <label for="phone">{{ $i18n.t('signup-userdetails-mobile') }}*</label>
          </div>
          <div class="form-item-component">
            <!-- areacode -->
            <div
              id="area-code"
              class="area-code-input-wrapper"
              v-clickOutside="popoverOutsideClick"
              @click="toggleAreaList"
            >
              <span class="">+{{ formData.dialCode }}</span>
              <img src="~img/icon-arrow-down.svg" alt="img-open" />
            </div>
            <!-- phonenumber -->
            <SafeInput
              :className="{
                'signup-form-item': true,
                'phone-number-input': true,
                'input-border-err': phoneInfoErr,
              }"
              :type="phoneInputType"
              id="phone"
              :placeholder="$i18n.t('mobileNumber')"
              autocomplete="new-password"
              role="input phone"
              v-model="formData.phone"
              maxlength="15"
              @input="
                e => {
                  handleValueChange(e, 'phone');
                }
              "
            />
            <img
              v-show="showPhone"
              class="eye"
              src="~img/icon-feather-eye-on.svg"
              @click="changePhoneStatus('password')"
              alt="hide phone"
            />
            <img
              v-show="!showPhone"
              class="eye"
              src="~img/icon-feather-eye-off.svg"
              @click="changePhoneStatus('text')"
              alt="show phone"
            />
            <!-- 下拉展示部分 -->
            <transition name="fade">
              <div class="area-code-popover" ref="" v-show="showAreaCodePopover">
                <div class="area-code-popover-content">
                  <div class="search-input-wrapper">
                    <!-- <label for="area-code" class="hide">area code</label> -->
                    <input
                      type="text"
                      class="search-input"
                      autocomplete="off"
                      v-model="searchText"
                      data-search-type="search"
                    />
                    <img class="icon-search" src="~img/search-Icon.png" alt="search area code" />
                  </div>
                  <div class="area-code-list-wrapper">
                    <ul class="area-code-list" role="listbox">
                      <li
                        :data-index="index"
                        :key="`${index}-${ctr.telabbr}`"
                        role="option"
                        v-for="(ctr, index) in showList"
                        class="area-code-item"
                        @click="areaItemClick(ctr)"
                      >
                        <span class="area-name">{{ ctr.name }}</span>
                        &nbsp;
                        <span class="area-code">(+{{ ctr.telabbr }})</span>
                      </li>
                      <li role="option" class="search-no-results" v-show="showList.length === 0">
                        {{ $i18n.t('search-box-no-found') }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <!-- check 错误提示 -->
          <p v-if="phoneInfoErr" class="error-message">{{ phoneErrMsg }}</p>
        </div>
        <!-- signup email输入框 -->
        <div class="form-item-group">
          <div class="form-item-label">
            <label for="email">{{ $i18n.t('signup-userdetails-email') }}*</label>
          </div>
          <div class="form-item-component">
            <SafeInput
              :className="{ 'signup-form-item': true, 'input-border-err': emailInfoErr }"
              :type="emailInputType"
              id="email"
              :placeholder="$i18n.t('mbs-email')"
              autocomplete="new-password"
              role="input email"
              v-model.trim="formData.email"
              maxlength="50"
              @input="
                e => {
                  handleValueChange(e, 'email');
                }
              "
            />
            <img
              v-show="showEmail"
              class="eye"
              src="~img/icon-feather-eye-on.svg"
              @click="changeEmailStatus('password')"
              alt="hide email"
            />
            <img
              v-show="!showEmail"
              class="eye"
              src="~img/icon-feather-eye-off.svg"
              @click="changeEmailStatus('text')"
              alt="show email"
            />
          </div>
          <!-- check 错误提示 -->
          <p v-if="emailInfoErr" class="error-message">{{ emailErrMsg }}</p>
        </div>
      </div>
    </div>
    <!-- <div class="signup-terms-box">
      <ul>
        <li>{{ $t('desc') }}</li>
        <li>
          <i18n-t keypath="see" tag="p">
            <router-link to="/privacypolicy" target="_blank" class="tc-link">{{
              $t('Privacy-Policy')
            }}</router-link>
            <a
              :href="
                $i18n.locale === 'fr_CA'
                  ? 'https://www.visa.ca/fr_CA/legal/global-privacy-notice.html'
                  : 'https://www.visa.ca/en_CA/legal/global-privacy-notice.html'
              "
              target="_blank"
              class="tc-link"
              >{{ $t('notice') }}</a
            >
            <router-link to="/terms" target="_blank" class="tc-link">{{
              $t('Program-TC')
            }}</router-link>
            <router-link to="/termsofservice" target="_blank" class="tc-link">{{
              $t('service')
            }}</router-link>
            <router-link to="/termsofuse" target="_blank" class="tc-link">{{
              $t('Term-Of-Use')
            }}</router-link>
          </i18n-t>
        </li>
        <li>{{ $t('signup-userdetails-adult') }}</li>
      </ul>
      <div class="check-terms">
        <div class="check-box" @click="toggleCheck">
          <img v-show="checked" src="~img/icon-check.png" alt="checked icon" />
        </div>
        <span>{{ $i18n.t('signup-userdetails-agree') }}</span>
      </div>
    </div> -->
    <div class="signup-terms-box">
      <p>{{ $t('please-accept') }}</p>
      <div class="check-box">
        <input name="privacyChecked" type="checkbox" v-model="privacyChecked" />
        <i18n-t keypath="agree-privacy" tag="p" class="check-desc">
          <router-link to="/privacypolicy" target="_blank" class="underline-link">{{
            $t('Privacy-Policy')
          }}</router-link>
          <a
            :href="
              $i18n.locale === 'fr_CA'
                ? 'https://www.visa.ca/fr_CA/legal/global-privacy-notice.html'
                : 'https://www.visa.ca/en_CA/legal/global-privacy-notice.html'
            "
            target="_blank"
            class="underline-link"
            >{{ $t('visa-privacy-notice') }}</a
          >
        </i18n-t>
      </div>
      <div class="check-box">
        <input name="termsChecked" type="checkbox" v-model="termsChecked" />
        <i18n-t keypath="agree-terms" tag="p" class="check-desc">
          <router-link to="/terms" target="_blank" class="underline-link">{{
            $t('Program-TC')
          }}</router-link>
          <router-link to="/termsofservice" target="_blank" class="underline-link">{{
            $t('service')
          }}</router-link>
          <router-link to="/termsofuse" target="_blank" class="underline-link">{{
            $t('Term-Of-Use')
          }}</router-link>
        </i18n-t>
        <!-- <p class="check-desc">
          I agree to the
          <router-link to="/terms" target="_blank" class="underline-link">{{
            $t('Program-TC')
          }}</router-link
          >, which includes
          <router-link to="/termsofservice" target="_blank" class="underline-link">{{
            $t('service')
          }}</router-link>
          and
          <router-link to="/termsofuse" target="_blank" class="underline-link">{{
            $t('Term-Of-Use')
          }}</router-link>
        </p> -->
      </div>
      <div class="divider"></div>
      <ul>
        <li>
          {{ $t('agree-desc') }}
        </li>
        <li>{{ $t('agree-over-18') }}</li>
      </ul>
    </div>
    <div class="signup-terms-box">
      <p>{{ $t('please-select') }}</p>
      <div class="check-box">
        <input name="thirdToolsChecked" type="checkbox" v-model="thirdToolsChecked" />
        <p class="check-desc">
          {{ $t('allow-third-tools') }}
        </p>
      </div>
      <div class="check-box">
        <input name="marketingChecked" type="checkbox" v-model="marketingChecked" />
        <p class="check-desc">
          {{ $t('allow-marketing-consent') }}
        </p>
      </div>
      <div class="divider"></div>
      <i18n-t keypath="third-tools-description" tag="p" class="check-desc">
        <router-link to="/privacypolicy" target="_blank" class="underline-link">{{
          $t('Privacy-Policy')
        }}</router-link>
        <a
          :href="
            $i18n.locale === 'fr_CA'
              ? 'https://www.visa.ca/fr_CA/legal/global-privacy-notice.html'
              : 'https://www.visa.ca/en_CA/legal/global-privacy-notice.html'
          "
          target="_blank"
          class="underline-link"
          >{{ $t('notice') }}</a
        >
        <router-link to="/feedback" class="underline-link">{{ $t('contact-us-form') }}</router-link>
      </i18n-t>
    </div>
    <!-- check 错误提示 -->
    <p v-if="infoErr" class="error-message">{{ errorMsg }}</p>
    <div class="signup-box-button">
      <div class="signup-btn" :class="{ 'signup-btn-disable': buttonDisable }">
        <div v-if="!loading" @click="checkUserInfo" role="button">
          <!-- <img src="~img/icon-lock.svg" alt="lock" /> -->
          <span>{{ $i18n.t('signup-userdetails-continue') }}</span>
        </div>
        <img v-else class="btn-loading" src="~img/loading.gif" alt="" />
      </div>
    </div>
    <DialogModal :showDialogModal="showDetailConfirm" :showCancelBtn="false">
      <template #content>
        <div class="modal-box">
          <!-- <div style="height: 40px"></div> -->
          <h1 class="modal-title">{{ $i18n.t('signup-confirm-title') }}</h1>
          <h6 class="moda-desc">{{ $i18n.t('signup-confirm-desc') }}</h6>
          <div class="modal-info fs-mask">
            <p>+{{ formData.dialCode }} {{ formData.phone }}</p>
            <p>{{ formData.email }}</p>
          </div>
          <button class="model-confirm" @click="nextStep">
            {{ $i18n.t('signup-confirm-yes') }}
          </button>
          <p
            class="model-cancel"
            @click="
              () => {
                showDetailConfirm = !showDetailConfirm;
              }
            "
          >
            {{ $i18n.t('signup-confirm-no') }}
          </p>
        </div>
      </template>
    </DialogModal>
  </div>
</template>
<script>
  import verify from '@/utils/verify';
  import { clickOutside } from '@/utils/directive.js';
  import DialogModal from '@/components/BaseUi/DialogModal';
  import SafeInput from '@/components/SafeInput';

  export default {
    name: 'SignUpMFAStep2',
    props: {},
    components: { DialogModal, SafeInput },
    directives: { clickOutside },
    data() {
      return {
        // firstname输入框
        fnameInputType: 'text',
        fnameInfoErr: false,
        fnameErrMsg: '',
        // lastname输入框
        lnameInputType: 'text',
        lnameInfoErr: false,
        lnameErrMsg: '',
        // areacode输入框
        areaList: [],
        searchText: '',
        showAreaCodePopover: false,
        phoneInputType: 'password',
        phoneInfoErr: false,
        phoneErrMsg: '',
        // email输入框
        emailInputType: 'password',
        emailInfoErr: false,
        emailErrMsg: '',
        // 勾选框
        // checked: false,
        privacyChecked: false,
        termsChecked: false,
        thirdToolsChecked: false,
        marketingChecked: false,
        formData: {
          fname: '',
          lname: '',
          dialCode: '1',
          phone: '',
          email: '',
        },
        infoErr: false,
        errorMsg: '',
        loading: false,
        showDetailConfirm: false,
      };
    },
    computed: {
      showFName() {
        return this.fnameInputType === 'text';
      },
      showLName() {
        return this.lnameInputType === 'text';
      },
      showPhone() {
        return this.phoneInputType === 'text';
      },
      showEmail() {
        return this.emailInputType === 'text';
      },
      buttonDisable() {
        const { fname, lname, phone, email } = this.formData;
        return (
          !fname ||
          !lname ||
          !phone ||
          !(phone.length >= 7 && phone.length <= 15) ||
          !email ||
          !this.privacyChecked ||
          !this.termsChecked
        );
      },
      showList() {
        let searchText = this.searchText || '';
        let data = this.areaList.filter(ctr => ctr.name && ctr.telabbr && ctr.code);
        if (searchText.length === 0) {
          return data;
        }
        searchText = searchText.replace('+', '\\+');
        data = data.filter(ctr => {
          const reg = new RegExp(searchText, 'gi');
          const nameFlag = reg.test(ctr.name);
          const dialCodeFlag = reg.test(ctr.telabbr);
          const iso2Flag = reg.test(ctr.ios2);
          return nameFlag || dialCodeFlag || iso2Flag;
        });
        return data;
      },
    },
    mounted() {
      this.getAreaList();
    },
    methods: {
      changeFNameInputStatus(value) {
        this.fnameInputType = value;
      },
      changeLNameStatus(value) {
        this.lnameInputType = value;
      },
      changePhoneStatus(value) {
        this.phoneInputType = value;
      },
      changeEmailStatus(value) {
        this.emailInputType = value;
      },
      // toggleCheck() {
      //   this.checked = !this.checked;
      // },
      toggleAreaList() {
        this.showAreaCodePopover = !this.showAreaCodePopover;
      },
      popoverOutsideClick(e) {
        if (e.target.className.includes('search-input')) return;
        this.showAreaCodePopover = false;
      },
      areaItemClick(ctr) {
        this.showAreaCodePopover = false;
        this.formData.dialCode = ctr.telabbr;
      },
      checkUserInfo() {
        console.log('check card');
        if (this.buttonDisable) return;
        verify(this.formData).then(async errMsg => {
          console.log(errMsg);
          if (errMsg.pass) {
            this.$loading.show();
            const { email } = this.formData;
            this.$http.login.checkUserInfo({ email }).then(res => {
              if (res.state === '11') {
                this.$loading.hide();
                // 弹窗确认
                this.showDetailConfirm = true;
              } else if (res.state === '00') {
                this.$loading.hide();
                this.emailInfoErr = true;
                this.emailErrMsg = res?.note;
              }
            });
          } else {
            errMsg.forEach(item => {
              switch (item.name) {
                case 'fname':
                  this.fnameInfoErr = true;
                  this.fnameErrMsg = item.errMessage;
                  break;
                case 'lname':
                  this.lnameInfoErr = true;
                  this.lnameErrMsg = item.errMessage;
                  break;
                case 'phone':
                  this.phoneInfoErr = true;
                  this.phoneErrMsg = item.errMessage;
                  break;
                case 'email':
                  this.emailInfoErr = true;
                  this.emailErrMsg = item.errMessage;
                  break;
                default:
                  break;
              }
            });
          }
        });
      },
      getAreaList() {
        this.$http.login
          .areaCodeList(localStorage.getItem('lang'))
          .then(res => {
            if (res?.state === '11') {
              this.areaList = Object.freeze(res.list) || [];
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      handleValueChange(e, key) {
        switch (key) {
          case 'fname':
            this.fnameInfoErr = false;
            this.fnameErrMsg = '';
            break;
          case 'lname':
            this.lnameInfoErr = false;
            this.lnameErrMsg = '';
            break;
          case 'phone':
            this.phoneInfoErr = false;
            this.phoneErrMsg = '';
            this.$nextTick(() => {
              this.formData.phone = e.target.value.replace(/[^\d]/g, '');
            });
            break;
          case 'email':
            this.emailInfoErr = false;
            this.emailErrMsg = '';
            break;
          default:
            break;
        }
      },
      nextStep() {
        console.log('下一步');
        this.showAreaCodePopover = false;
        this.$emit('nextStep', {
          formData: {
            ...this.formData,
            allowTracking: this.thirdToolsChecked ? 1 : 2,
            allowReceiving: this.marketingChecked ? 1 : 2,
          },
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  @import './index.scss';
  @import './mobile.scss';
</style>
